'use strict';exports.__esModule = true;exports.homeCarouselArrowClassName = undefined;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;}; // Modules
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var homeCarouselArrowClassName = exports.homeCarouselArrowClassName = 'home-carousel-arrow';

var getSlidesCount = function getSlidesCount(cellWidth, spaceBetween, screenWidth) {
  var width = screenWidth || global && global.document && global.document.body.clientWidth;
  return width ?
  width / (cellWidth + spaceBetween) :
  'auto';
};

var getParams = function getParams(screenWidth) {return {
    spaceBetween: 16,
    slidesOffsetBefore: 222,
    slidesOffsetAfter: 2,
    rebuildOnUpdate: true,
    slidesPerView: getSlidesCount(306, 40, 1280),
    preloadImages: false,
    lazy: { loadOnTransitionStart: true },
    breakpoints: {
      1024: {
        slidesPerView: getSlidesCount(316, 30, screenWidth) },

      767: {
        slidesOffsetBefore: 16,
        slidesPerView: getSlidesCount(310, 0, screenWidth),
        navigation: {
          nextEl: null,
          prevEl: null } } } };};





var Slider = function Slider(props) {return (
    _react2.default.createElement(_reactIdSwiper2.default, _extends({},
      getParams(props.screenWidth), {
        initialSlide: props.initialSlide,
        ref: props.innerRef,
        on: {
          slideChange: props.handleSlideChange,
          click: props.handleClick },

        noSwiping: props.noSwiping }),

      props.children));};



Slider.propTypes = {
  children: _propTypes2.default.array,
  initialSlide: _propTypes2.default.number,
  handleSlideChange: _propTypes2.default.func,
  handleClick: _propTypes2.default.func,
  innerRef: _propTypes2.default.func,
  screenWidth: _propTypes2.default.number,
  noSwiping: _propTypes2.default.bool };exports.default =


Slider;


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/components/Slider.js
// module id = 2777
// module chunks = 0